export default __webpack_public_path__ + "static/media/main-window-min.aeac5141.jpg";